import {
    makeExecutorUrl,
    trans,
} from '@frontend/helpers'
import type {ChatExecutorData} from '@frontend/modules/private/chats/ChatsModuleTypes'
import {Link} from 'react-router-dom'
import {chatCoverPlaceholder} from './ChatCover'

interface Props {
    executor: ChatExecutorData
}

// Информация об исполнителе, который предлагает свои услуги по объявлению
// из категорий типа "Нужна услуга".
export function ChatDetailsExecutorForAd(props: Props) {

    const {
        executor,
    } = props

    return (
        <Link
            to={makeExecutorUrl(executor.slugWithId, executor.categorySlugWithId)}
            target="_blank"
            rel="noreferrer"
            className="chat-executor-info link-dark d-flex flex-row align-items-center gap-small p-3 mb-3 rounded-8 chat-surface"
        >
            <img
                src={executor.cover || chatCoverPlaceholder}
                alt=""
                width={60}
                height={60}
                className="rounded-7 flex-shrink-0"
            />
            <div className="flex-1 d-flex flex-column gap-1 overflow-hidden">
                <span className="text-muted fs-7">
                    {trans().cabinet.chats.executor_profile}
                </span>
                <span className="fw-800 text-truncate">
                    {executor.title}
                </span>
                <span className="text-muted fs-7">
                    {trans().cabinet.chats.executor_category}: {executor.category}
                </span>
            </div>
        </Link>
    )
}
